<div class="sequence">
  @if (isRuleExpanded()) {
    <div class="sequence__header">
      <div class="sequence__header-info">
        @if (
          scheduleService()?.config?.hasCommunicationInterval ||
          scheduleService()?.config?.hasFixRate
        ) {
          <vectronic-header-group
            [title]="
              scheduleService()?.config?.hasCommunicationInterval
                ? 'Communication Interval'
                : 'Fix Rate'
            "
            icon="access_time"
            [headerTooltip]="
              !scheduleService()?.config?.hasCommunicationInterval
                ? 'Position acquisition frequency'
                : undefined
            "
          >
            <vectronic-header-item
              [value]="getFixRateString()"
              [readonly]="readonly()"
              (openChange)="onFixRateOpenChange($event)"
            >
              <div class="sequence__item">
                @if (scheduleService()?.config?.hasFixRate && periodLength() > 1440) {
                  <vectronic-header-field
                    class="sequence__field"
                    type="number"
                    label="Day"
                    [control]="fixRateDayFormControl"
                    [min]="0"
                    [max]="maxFixRateDays()"
                  ></vectronic-header-field>
                }
                <vectronic-header-field
                  class="sequence__field"
                  type="number"
                  label="Hour"
                  [control]="fixRateHourFormControl"
                  [min]="0"
                  [max]="
                    scheduleService()?.config?.hasFixRate
                      ? periodLength() === 1440
                        ? 24
                        : 23
                      : undefined
                  "
                ></vectronic-header-field>
                <vectronic-header-field
                  class="sequence__field"
                  type="number"
                  label="Minute"
                  [control]="fixRateMinuteFormControl"
                  [min]="0"
                  [max]="59"
                ></vectronic-header-field>
              </div>
            </vectronic-header-item>
          </vectronic-header-group>
        }
        <vectronic-header-group
          headerTooltip="Begin position acquisition"
          [title]="'Start'"
          icon="compare_arrows"
        >
          <vectronic-header-item [value]="getStartString()" [readonly]="readonly()">
            <div class="sequence__item">
              @if (isWeekly()) {
                <vectronic-header-field
                  class="sequence__field"
                  type="select"
                  label="Weekday"
                  [options]="weekdays"
                  [control]="startWeekdayFormControl"
                  (valueChange)="onStartWeekdayChanged($event)"
                ></vectronic-header-field>
              }
              <vectronic-header-field
                class="sequence__field"
                type="number"
                label="Hour"
                [control]="startHourFormControl"
                (valueChange)="updateStart()"
                [min]="0"
                [max]="isWeeklyOrDaily() ? 23 : undefined"
              ></vectronic-header-field>
              <vectronic-header-field
                class="sequence__field"
                type="number"
                label="Minute"
                [control]="startMinuteFormControl"
                (valueChange)="updateStart()"
                [min]="0"
                [max]="59"
              ></vectronic-header-field>
            </div>
          </vectronic-header-item>
        </vectronic-header-group>

        <vectronic-header-group
          headerTooltip="Stop position acquisition"
          [title]="'End'"
          icon="compare_arrows"
        >
          <vectronic-header-item [value]="getEndString()" [readonly]="readonly()">
            <div class="sequence__item">
              @if (isWeekly()) {
                <vectronic-header-field
                  class="sequence__field"
                  type="select"
                  label="Weekday"
                  [options]="weekdays"
                  [control]="endWeekdayFormControl"
                  (valueChange)="onEndWeekdayChanged($event)"
                ></vectronic-header-field>
              }
              <vectronic-header-field
                class="sequence__field"
                type="number"
                label="Hour"
                [control]="endHourFormControl"
                (valueChange)="updateEnd()"
                [min]="0"
                [max]="isWeeklyOrDaily() ? 24 : undefined"
              ></vectronic-header-field>
              <vectronic-header-field
                class="sequence__field"
                type="number"
                label="Minute"
                [control]="endMinuteFormControl"
                (valueChange)="updateEnd()"
                [min]="0"
                [max]="59"
              ></vectronic-header-field>
            </div>
          </vectronic-header-item>
        </vectronic-header-group>
        <div class="sequence__header-space"></div>
        @if (isRuleExpanded()) {
          <div class="sequence__legend">
            <div class="sequence__legend-offset"></div>
            <span>Offset</span>
            @if (
              scheduleService()?.config?.hasFixRate ||
              scheduleService()?.config?.hasCommunicationInterval
            ) {
              <div
                [ngClass]="{
                  'sequence__legend-fix': hasTransmissionCount(),
                  'sequence__legend-transmission': !hasTransmissionCount(),
                }"
              ></div>
              <span>{{
                scheduleService()?.config?.hasCommunicationInterval ? 'Transmissions' : 'Fix'
              }}</span>
              @if (scheduleService()?.config?.hasSkipCount) {
                <div class="sequence__legend-skip"></div>
                <span>Skip</span>
              }
              @if (hasTransmissionCount()) {
                <div class="sequence__legend-transmission"></div>
                <span>Transmission</span>
              }
            }
            @if (isBeacon()) {
              <div class="sequence__legend-beacon"></div>
              <span>Active</span>
            }
          </div>
        }
        @if (!readonly()) {
          <div [matTooltip]="isDeletable() ? 'Delete Sequence' : 'Specify at least one fix rate'">
            <button
              mat-icon-button
              (click)="onClickRemoveSequence()"
              color="warn"
              [disabled]="!isDeletable()"
              [attr.data-testid]="'delete-sequence-button'"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        }
      </div>
    </div>
    @if (periodLength() === 10080) {
      <p class="sequence__hint">
        For weekly interval, the first displayed day of the week is equal to the day of week of the
        start date
      </p>
    }
    <rc-sequence-preview
      [fixRate]="fixRate()"
      [duration]="duration()"
      [offset]="offset()"
      [periodLength]="periodLength()"
      [startDate]="startDate()"
      [skipPosition]="skipPosition()"
      [isCommunication]="scheduleService().config.hasCommunicationInterval"
      [fixPerTransmission]="scheduleService().fixPerTransmission$.value?.[ruleIndex()]"
      [isBeacon]="isBeacon()"
    ></rc-sequence-preview>
    @if (!readonly() && periodLength()) {
      <rc-schedule-range-slider
        [offset]="offset()"
        [duration]="duration()"
        [periodLength]="periodLength()"
        [startDate]="startDate()"
        (valueChange)="onSliderValueChange($event)"
      ></rc-schedule-range-slider>
    }
  } @else {
    <div (click)="clickSummary.emit()">
      @if (
        scheduleService().config.hasFixRate || scheduleService().config.hasCommunicationInterval
      ) {
        <span>Fix Rate: {{ getFixRateString() }} | </span>
      }
      <span>{{ getStartString() }}</span>
      <span> -> {{ getEndString() }}</span>
    </div>
  }
</div>
